<template>
    <div id="modal_movimento_info" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <header>
                    <div class="header">
                        <img class="logo-ods" :src="logoODS" />
                        <h4 class="modal-title">{{ content.instituicao }}</h4>
                    </div>
                    <div class="subheader">
                        <h2>{{ content.titulo }}</h2>
                        <div class="body">
                            <div class="container-date">
                                <font-awesome-icon class="label-color" :icon="['far', 'calendar-alt']" size="lg" />
                                <span>{{ content.dataInicio }} - {{ content.dataEncerramento }}</span>
                            </div>
                            <div class="container-local">
                                <font-awesome-icon class="label-color" :icon="['fas', 'map-marker-alt']" size="lg" />
                                <span>{{ content.local }}</span>
                            </div>
                        </div>
                    </div>
                </header>

                <main :style="{ height: 'auto' }">
                    <p class="description">{{ content.descricao }}</p>

                    <p>
                        <span>Número de participantes: </span>
                        <span>{{ content.totalParticipantes }}</span>
                    </p>

                    <p>
                        <span>Tipo de ação: </span>
                        <span>{{ content.tipo_acao }}</span>
                    </p>

                    <section class="flags">
                        <p>Bandeiras</p>
                        <div>
                            <img v-for="({ titulo, img }) in listBandeirasInfo(content.bandeiras)" :src="img"
                                :title="titulo" :alt="titulo">
                        </div>
                    </section>

                    <section v-show="content.link_instrucoes" class="instruction">
                        <p>Como participar?</p>
                        <p><a :href="content.link_instrucoes">{{ content.link_instrucoes }}</a></p>
                    </section>

                    <section v-show="content.link_fotos" class="instruction">
                        <p>Acesse aqui algumas fotos</p>
                        <p><a :href="content.link_fotos">{{ content.link_fotos }}</a></p>
                    </section>

                </main>

                <footer>
                    <button @click="close">Sair</button>
                </footer>
            </div>
        </div>
    </div>
</template>
  
<script>
import logoODS from '../../assets/css/img/ods/logo/movimento_ods_logo.jpg'

export default {
    name: 'ModalMovimentoInfo',
    data() {
        return {
            content: {
                instituicao: '',
                titulo: '',
                dataInicio: '',
                dataEncerramento: '',
                local: '',
                descricao: '',
                tipo_acao: '',
                totalParticipantes: 0,
                bandeiras: '',
                link_instrucoes: '',
                link_fotos: '',
                email: ''
            },
            logoODS
        }
    },
    methods: {
        show(content) {
            this.setContents(content)
            window.jQuery('#modal_movimento_info').modal('show')
        },
        setContents(content) {
            this.content = content
        },
        close() {
            window.jQuery('#modal_movimento_info').modal('hide')
        },
        listBandeirasInfo(bandeiras) {
            const array = bandeiras.toLowerCase() === 'todas'
                ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
                : bandeiras.split(/\D+/)

            return array.map(b => this.getBandeiraInfo(b))
        },
        getBandeiraInfo(bandeira) {
            return {
                img: this.getBandeiraImg(bandeira),
                titulo: this.getBandeiraTitulo(bandeira)
            }
        },
        getBandeiraImg(bandeira) {
            return require(`../../assets/css/img/ods/flags/${bandeira}.jpg`)
        },
        getBandeiraTitulo(bandeira) {
            const titulos = [
                '1. Erradicação da pobreza',
                '2. Fome zero e agricultura sustentável',
                '3. Saúde e Bem-Estar',
                '4. Educação de qualidade',
                '5. Igualdade de género',
                '6. Água potável e saneamento',
                '7. Energia limpa e acessível',
                '8. Trabalho decente e crescimento económico',
                '9. Indústria, inovação e infraestrutura',
                '10. Redução das desigualdades',
                '11. Cidades e comunidades sustentáveis',
                '12. Consumo e produção responsáveis',
                '13. Ação contra a mudança global do clima',
                '14. Vida na água',
                '15. Vida terrestre',
                '16. Paz, justiça e instituições eficazes',
                '17. Parcerias e meios de implementação'
            ]

            return titulos[Number(bandeira) - 1]
        }
    }
}
</script>
  
<style scoped>
div.modal-content {
    max-width: 800px;
    margin: 10px auto;
    border-radius: 10px;
    overflow: hidden;
}

header {
    padding-top: 16px;
    padding-inline: 16px;
    text-align: center;
}

.header {
    display: flex;
    border-bottom: solid 1px #b5b4b4;
}

header img.logo-ods {
    width: 128px;
    border: solid 2px rgb(13, 41, 27, 0.7);
    border-radius: 10px;
    margin-right: 16px;
    margin-bottom: 16px;
}

header div.subheader h2 {
    text-align: left;
    font-weight: 400;
    font-size: 3rem;
    font-style: normal;
    color: #212529;
}

header div.subheader div.body {
    display: flex;
    justify-content: start;
    border-bottom: dashed 1px #b5b4b4;
    padding-bottom: 8px;
}

.container-date {
    margin-right: 8px;
}

.container-date,
.container-local {
    display: flex;
    align-items: center;

    font-size: 1.5rem;
    font-style: normal;
    color: #212529;
}

.container-date>*:first-child,
.container-local>*:first-child {
    margin-right: 8px;
}

header h4 {
    margin-top: 10px;
}

main {
    overflow-y: auto;
    padding-inline: 16px;
    background-color: white;
}

main .description {
    padding: 16px 0px;

    font-size: 1.5rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;

    border-bottom: dashed 1px #b5b4b4;
}

main p {
    padding: 4px;
    border-bottom: dashed 1px #b5b4b4;
}

main p>span:first-child {
    text-transform: uppercase;
    color: #697473;
}

main p>span {
    color: #212529;
}

main .label-row {
    display: flex;
    justify-content: space-between;
}

footer {
    display: flex;
    justify-content: center;
    align-items: center;
}

footer button {
    background-color: rgb(13, 41, 27, 0.7);
    color: white;
    width: 200px;
    height: 40px;
    text-transform: uppercase;
    text-align: center;
    border: 0;
    border-radius: 20px;
    transition: background-color 0.5s;
    margin-bottom: 8px;
}

footer button:hover {
    background-color: rgb(13, 41, 27, 0.9);
}

.label-color {
    color: #697473;
}

section.flags {
    padding-bottom: 8px;
    margin-bottom: 10px;
    border-bottom: dashed 1px #b5b4b4;
}

section.flags p {
    text-transform: uppercase;
    border: none;
    margin: 0px;
}

section.flags div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

section.flags div img {
    width: 50px;
    margin-right: 2px;
    margin-bottom: 2px;
}

.instruction {
    padding: 16px;
    background-color: #e9ecef;
    margin-bottom: 10px;
}

.instruction p:first-child {
    text-transform: uppercase;
    border: none;
    margin: 0px;
}

.instruction p {
    border: none;
    margin: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/ODS/ModalMovimentoInfo.vue